import * as React from "react";
const SvgPencil = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "pencil_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M16.187 3.511a.514.514 0 0 0-.707 0L4.067 14.924a.5.5 0 0 0 0 .707l4.28 4.28a.5.5 0 0 0 .707 0L20.467 8.5a.5.5 0 0 0 0-.707Z" }), /* @__PURE__ */ React.createElement("path", { d: "M3 16.71a.5.5 0 0 0-.828.2l-2.14 6.42a.5.5 0 0 0 .12.512.51.51 0 0 0 .512.121l6.42-2.139a.5.5 0 0 0 .2-.829Z" }), /* @__PURE__ */ React.createElement("path", { d: "M22.968 1.017a3.613 3.613 0 0 0-4.988 0l-.712.713a.5.5 0 0 0 0 .707l4.279 4.28a.5.5 0 0 0 .707 0L22.968 6a3.53 3.53 0 0 0 0-4.983" }));
export { SvgPencil as ReactComponent };
